export default {
  grade: {
    value: "F7",
    options: ["F7", "M5"],
  },
  rows: [0.75, 0.25],
  columns: [0.3, 0.3, 0.4],
  length: 50,
};
